import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { track } from "../lib/analytics";

export const CopyBtn = ({ text, label = "copy", testId = "copy-btn", analyticsEvent, analyticsParams }) => {
  const [ok, setOk] = useState(false);
  const doCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setOk(true);
      if (analyticsEvent) track(analyticsEvent, analyticsParams || {});
      toast.success("copied to clipboard", { className: "font-mono" });
      setTimeout(() => setOk(false), 1500);
    } catch {
      toast.error("copy failed");
    }
  };
  return (
    <button
      data-testid={testId}
      onClick={doCopy}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] uppercase tracking-widest border border-white/15 hover:border-[color:var(--accent-amber)] hover:text-[color:var(--accent-amber)] duration-150"
      style={{ transitionProperty: "color, border-color" }}
    >
      {ok ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />}
      {ok ? "copied" : label}
    </button>
  );
};
